import React, { createContext, useContext, useState, useEffect } from "react";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../translations";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const { language } = useLanguage(); // Текущий язык
  // const [lastSearchResult, setLastSearchResult] = useState(null); // Последний найденный результат

  const [lastSearchResult, setLastSearchResult] = useState(() => {
    return JSON.parse(sessionStorage.getItem("searchResult")) || null;
  });

  const extractTitles = (data) => {
    let titles = [];

    if (!data || typeof data !== "object") return [];

    const uniqueTitles = new Map();

    const addTitle = (title, path) => {
      const normalizedTitle = title.trim().toLowerCase();
      if (!uniqueTitles.has(normalizedTitle)) {
        uniqueTitles.set(normalizedTitle, { title, path });
      }
    };

    // Заголовки из `header`
    if (data.header && typeof data.header === "object") {
      Object.entries(data.header).forEach(([key, value]) => {
        if (typeof value === "string") {
          addTitle(value, `/${key}`);
        }
      });
    }

    // Обрабатываем остальные разделы
    const processSection = (section, path) => {
      if (section && typeof section === "object") {
        if (section.title) {
          addTitle(section.title, path);
        }
        if (Array.isArray(section.sections)) {
          section.sections.forEach((subSection, index) => {
            const newPath = `${path}/section-${index + 1}`;
            processSection(subSection, newPath);
          });
        }
      }
    };

    Object.entries(data).forEach(([key, section]) => {
      if (section && typeof section === "object" && key !== "header") {
        processSection(section, `/${key}`);
      }
    });

    return Array.from(uniqueTitles.values()).sort((a, b) =>
      a.title.localeCompare(b.title)
    );
  };

  const searchData = extractTitles(translations[language]); // Используем текущий язык

  useEffect(() => {
    if (lastSearchResult) {
      sessionStorage.setItem("searchResult", JSON.stringify(lastSearchResult));
    }
  }, [lastSearchResult]);


  useEffect(() => {
    if (!lastSearchResult) return;
  
    const newSearchData = extractTitles(translations[language]);
    
    // 1️⃣ Пытаемся найти новый результат по `path`
    let matchedResult = newSearchData.find((item) => item.path === lastSearchResult.path);
  
    // 2️⃣ Если `path` не найден, пробуем найти по `title`
    if (!matchedResult) {
      matchedResult = newSearchData.find(
        (item) => item.title.toLowerCase() === lastSearchResult.title.toLowerCase()
      );
    }
  
    // 3️⃣ Если `title` не найден, пробуем найти эквивалент в оригинальном языке
    if (!matchedResult) {
      const originalLanguage = language === "pl" ? "en" : "pl";
      const originalData = extractTitles(translations[originalLanguage]);
  
      const originalMatch = originalData.find((item) => item.path === lastSearchResult.path);
  
      if (originalMatch) {
        matchedResult = newSearchData.find(
          (item) => item.title.toLowerCase() === originalMatch.title.toLowerCase()
        );
      }
    }
  
    // 4️⃣ Если ничего не найдено, НЕ сбрасываем старый результат!
    if (matchedResult) {
      setLastSearchResult(matchedResult);
      sessionStorage.setItem("searchResult", JSON.stringify(matchedResult));
    } else {
      sessionStorage.setItem("searchResult", JSON.stringify(lastSearchResult));
    }
  }, [language]);
  

  return (
    <SearchContext.Provider
      value={{ searchData, lastSearchResult, setLastSearchResult }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);
